import type { StateCreator } from 'zustand';

import { closeAllSections, resetGuidedDoctorConsult, setFieldsState, setIsDirty, toggleSection } from './actions';
import { DEFAULT_STATE } from './constants';
import { accordionInteractionAnimation } from './selectors';
import type { GuidedDoctorConsultsSliceType } from './types';

export const guidedDoctorConsultsSlice: StateCreator<
  GuidedDoctorConsultsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  GuidedDoctorConsultsSliceType
> = (set, get, store) => ({
  // State
  ...DEFAULT_STATE,

  // Selectors/Computed State
  accordionInteractionAnimation: () => accordionInteractionAnimation(get),

  // Actions
  setFieldsState: (key, value) => setFieldsState(set, get, store)(key, value),
  setIsDirty: (isDirty) => setIsDirty(set, get, store)(isDirty),
  toggleSection: (sectionName) => toggleSection(set, get, store)(sectionName),
  closeAllSections: () => closeAllSections(set, get, store)(),
  resetGuidedDoctorConsult: () => resetGuidedDoctorConsult(set, get, store)(),
});
